module.exports = __webpack_public_path__ + "img/icon-pen.628e1b5c.svg";